import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { TrustStrip } from '../components/sections/TrustStrip';
import { ServicesSection } from '../components/sections/ServicesSection';
import { WhyUsSection } from '../components/sections/WhyUsSection';
import { AfricanPresenceSection } from '../components/sections/AfricanPresenceSection';
import { WorkPreviewSection } from '../components/sections/WorkPreviewSection';
import { ProcessSection } from '../components/sections/ProcessSection';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { BlogPreviewSection } from '../components/sections/BlogPreviewSection';
import { CTASection } from '../components/sections/CTASection';
export function HomePage() {
  return <main data-id="element-1301">
      <HeroSection data-id="element-1302" />
      <ServicesSection data-id="element-1303" />
      <WhyUsSection data-id="element-1304" />
      <AfricanPresenceSection data-id="element-1305" />
      <WorkPreviewSection data-id="element-1306" />
      <ProcessSection data-id="element-1307" />
      <TestimonialsSection data-id="element-1308" />
      <CTASection data-id="element-1309" />
      <BlogPreviewSection data-id="element-1310" />
      <TrustStrip data-id="element-1311" />
    </main>;
}